import Splide from '@splidejs/splide';

export default function () {
	const splideContainer = document.querySelector('.product-carousel-splide');
	if (splideContainer !== null) {
		var splide = new Splide( '.product-carousel-splide', {
			arrows: true,
			pagination: false,
			autoplay: true,
			interval: 5000,
			type: 'loop',
			pauseOnHover: true,
			pauseOnFocus: true,
			autoHeight: true,
		} );
		if (splide === null) {
			return;
		} else {
			splide.mount();
		}
	}

	let productType = 'default'
	Object.defineProperty(window, 'productType', {
		get () {
			return productType
		},
		set(value) {
			productType = value
			if (splide) {
				let slides = splide.Components.Elements.slides
				if (slides) {
					for(let i = 0; i < slides.length; i++) {
						let slideSlug = slides[i].dataset.slidelabel
						if (slideSlug === productType) {
							splide.go(i)
							splide.Components.Autoplay.pause()
						}
					}
				}
			}
		}
	})
}
